// „Follow-UP Datum“ in der Custom Activity: reine Logik ohne Oberflächenimporte (Test: tests/followUp.test.mjs,
// Start: cd crm/web && node --test src/components/lead/tests/followUp.test.mjs).
// Follow-ups laufen wie in Close über das Lead-Feld „Follow-UP Datum“, nicht über Inbox-Aufgaben. Wählt der Caller im
// Formular eine Follow-Up-Option (jede Auswahl, deren Text „Follow-Up“ enthält, keine festen Nummern), erscheint das
// Datumsfeld; ein gesetztes Datum wird beim Speichern in das Lead-Feld geschrieben, leer = Feld bleibt unverändert.
// Die Datumsvorschläge (Morgen, Übermorgen, Nächste Woche, In 2 Wochen) stehen in inbox/schnellwahl.ts (followUpVorschlaege).

/** Schlüssel in den Formularwerten (gehört zu keinem Typfeld, geht nie als Feld an die API, bleibt aber im Entwurf). */
export const FOLLOWUP_WERT = "__followup_datum";
export const FOLLOWUP_FELDNAME = "Follow-UP Datum";
/** Rückfall, falls die Metadaten das Lead-Feld (noch) nicht kennen. */
export const FOLLOWUP_FELD_ID = "cf_RP7CakyDr9W2XYPTHoLVEtcuQ6rsYDjeNA5QKZUie50";

const FOLLOWUP_TEXT = /follow[\s_-]*up/i;

export function istFollowUpOption(text: unknown): boolean {
  return typeof text === "string" && FOLLOWUP_TEXT.test(text);
}

interface FeldKurz {
  id: string;
  type: string;
}

/** Hat der Caller in einem Auswahlfeld des Typs eine Follow-Up-Option gewählt? Die ID des Auslöserfelds oder null. */
export function followUpFeld(felder: FeldKurz[], werte: Record<string, unknown>): string | null {
  for (const f of felder) {
    if (f.type !== "choices") continue;
    const w = werte[f.id];
    const liste = Array.isArray(w) ? w : [w];
    if (liste.some(istFollowUpOption)) return f.id;
  }
  return null;
}

/** Das gesetzte Datum (YYYY-MM-DD) oder null, auch wenn die Follow-Up-Option inzwischen abgewählt wurde. */
export function followUpDatum(felder: FeldKurz[], werte: Record<string, unknown>): string | null {
  if (followUpFeld(felder, werte) === null) return null;
  const d = werte[FOLLOWUP_WERT];
  return typeof d === "string" && /^\d{4}-\d{2}-\d{2}$/.test(d) ? d : null;
}

/** ID des Lead-Felds „Follow-UP Datum“ (nach Name, Typ Datum), sonst die bekannte ID. */
export function followUpLeadFeldId(leadFelder: { id: string; name: string; type: string }[] | undefined): string {
  const treffer = leadFelder?.find((f) => f.type === "date" && f.name.trim().toLowerCase() === FOLLOWUP_FELDNAME.toLowerCase());
  return treffer?.id ?? FOLLOWUP_FELD_ID;
}
